import { useContext } from "react";

import { Navigate } from "react-router-dom";
import { UserContext } from "@context/user";
import { ComponentSpinner } from "@components/spinner";

// Bare `/publisher` has no publisher id to scope to yet — bounce to the active
// (or first) publisher account's overview once the topbar switcher has resolved one.
const PublisherIndexRedirect = () => {
    const { activePublisherId } = useContext(UserContext);

    if (!activePublisherId) {
        return (
            <div className="flex justify-center py-24">
                <ComponentSpinner />
            </div>
        );
    }

    return <Navigate replace to={`/publisher/${activePublisherId}/overview`} />;
};

export default PublisherIndexRedirect;
